//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
export default {
  name: 'SysCacheList',
  mixins: [JeecgListMixin],
  components: {},
  data: function data() {
    return {
      TechOptions: [],
      AssetsOptions: [],
      description: '系统缓存管理界面',
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      // 表头
      columns: [{
        title: '缓存名称',
        align: 'center',
        dataIndex: 'name'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 200,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        list: '/sys/cache',
        refreshEzvizAcount: '/sys/video/refresh/ezviz/acount'
      }
    };
  },
  created: function created() {
    this.loadData();
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    }
  },
  methods: {
    loadData: function loadData(arg) {
      console.log('arg', arg);
      this.initTableData(arg);
    },
    initTableData: function initTableData(arg) {
      var _this = this;

      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.loading = true;
      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          res.result.push({
            code: '',
            name: '萤石云子账户权限(批量刷新不生效)'
          });
          _this.dataSource = res.result;
        }

        if (res.code === 510) {
          _this.$notification.warning({
            message: res.message
          });
        }

        _this.loading = false;
      });
    },
    handleCache: function handleCache(record) {
      var _this2 = this;

      console.log('record', record);

      if (record.code === '') {
        getAction(this.url.refreshEzvizAcount).then(function (res) {
          if (res.success) {
            _this2.$notification.success({
              message: '刷新成功!'
            });

            _this2.loadData();
          }

          if (res.code === 510) {
            _this2.$notification.warning({
              message: res.message
            });
          }
        });
      } else {
        getAction(this.url.list + '/' + record.code).then(function (res) {
          if (res.success) {
            _this2.$notification.success({
              message: '刷新成功!'
            });

            _this2.loadData();
          }

          if (res.code === 510) {
            _this2.$notification.warning({
              message: res.message
            });
          }
        });
      }
    },
    batchCache: function batchCache() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择' + this.pageTitle + '记录！');
        return;
      } else {
        var ids = '';

        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }

        var that = this;
        this.$confirm({
          title: '确认刷新',
          content: '是否刷新选中数据?',
          onOk: function onOk() {
            getAction(that.url.list + '/' + ids).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: '刷新成功!'
                });
                that.loadData();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    }
  }
};